export const BASE_URL = "https://hc-server-ar0a.onrender.com/";
